export default (initialState = {}) => {
  return () => {
    return {
      _id: "",
      name: "",
      code: "",
      description: "",
      applicable_to: "internal",
      permissions: [],
      ...initialState,
    };
  };
};
